export const BASE_URL ="https://admin.redcarat.ae/public/storage/";
export const API_URL = "http://72.62.193.115:5001/api";
// https://admin.redcarat.ae/public/storage/
// http://www.redcarat.ae:5001